import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import ResponsiveDialog from './ResponsiveDialog';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  loading = false,
}) => (
  <ResponsiveDialog
    open={open}
    onClose={loading ? undefined : onClose}
    maxWidth="xs"
    fullWidth
    mobileFullScreen={false}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {typeof body === 'string' ? (
        <Typography variant="body2">{body}</Typography>
      ) : (
        body
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit" disabled={loading}>
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        color={confirmColor}
        onClick={onConfirm}
        disabled={loading}
        autoFocus
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </ResponsiveDialog>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  body: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'info', 'success']),
  loading: PropTypes.bool,
};

export default ConfirmDialog;
